export function useStructuredData() {

  const getStructuredDataForPage = (pageStructuredData, customRecords) => {

    // merge records from the page with custom records; when the same key is present in both, the page record will be used
    let mergedRecords = customRecords ? [...pageStructuredData, ...customRecords?.filter(cr => !pageStructuredData.some(pr => pr.key === cr.key))] : pageStructuredData;

    mergedRecords = mergedRecords.filter(record => !!record.key && !!record.value).map(record => { return { key: record.key, value: record.value.replaceAll('"', '&quot;') } });
    
    if (mergedRecords.some(record => record.key.startsWith('Article'))) {
      const organizationRecords = useAppConfig().organizationMetadataForStructuredData[useLocale().getLocale().language];

      mergedRecords = [...mergedRecords, ...Object.keys(organizationRecords).map(key => ({ key, value: organizationRecords[key] }))];
    }

    const result = generateStructuredData(mergedRecords);

    return result;
  }

  function generateStructuredData(data, header = true) {
    if (!data || data.length === 0) {
      return null;
    }

    const lines = [];
    const type = data[0].key.split('/')[0].split('#').pop();

    if (header) {
      lines.push('\t\t"@context": "http://schema.org"');
    }

    lines.push(`\t\t"@type": "${type}"`);

    const reducedData = data
      .filter(d => d.key.split('/').length === 2)
      .reduce((acc, d) => {
        const key = d.key.split('/').pop().split('#').pop();
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(d.value);
        return acc;
      }, {});

    Object.entries(reducedData).forEach(([key, value]) => {
      lines.push(`"${key}": ${value.length === 1 ? `"${value[0]}"` : `[${value.join(', ')}]`}`);
    });

    const children = data
      .filter(d => d.key.split('/').length > 2)
      .map(d => ({ key: d.key.split('/').slice(1).join('/'), value: d.value }))
      .reduce((acc, d) => {
        const key = d.key.split('/')[0];
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(d);
        return acc;
      }, {});

    Object.entries(children).forEach(([key, value]) => {
      const line = generateStructuredData(value, false);
      if (line.trim() !== '') {
        lines.push(`"${key.split('#')[0]}": ${line}`);
      }
    });

    return `{\n${lines.join(',\n')}}\n`;
  }

  return {
    getStructuredDataForPage
  }

}